var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center"},[_vm._v("\n    ©2020\n    "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.toHome()}}},[_vm._v("bluedio.com")]),_vm._v(" All right reserved\n")])}
var staticRenderFns = []

export { render, staticRenderFns }